export const LOGIN_USER = 'account.LOGIN_USER';
export const LOGOUT_USER = 'account.LOGOUT_USER';
export const SET_REDIRECT_TO = 'account.SET_REDIRECT_TO';
